module.exports = __webpack_public_path__ + "img/材料力学1_7_1.707e8e70.jpg";